import styled, { css } from 'styled-components';
import BlockIcon from '../../../../../icons/blockIcon.svg';

export const Box = styled.button<{ selected: boolean }>`
    cursor: pointer;
    background-color: transparent;
    display: flex;
    flex-direction: column;
    outline: none;
    margin: 5px;
    padding: 3px;
    border-width: 2px;
    border-style: solid;
    border-radius: 2px;
    width: 70px;
    height: 70px;
    border-color: #f0f0f0;
    position: relative;
    cursor: ${({ selected }) => (selected ? 'default' : 'pointer')};

    ${props =>
        props.selected &&
        css`
            border-color: var(--ant-primary-color);
        `}
`;

export const Inner = styled.div<{ image: string; color: string }>`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background: ${({ image, color }) => (image ? `center / cover no-repeat url(${image})` : color)};
`;

export const Container = styled.div`
    display: flex;
    margin-left: auto;
    margin-right: auto;
    flex-wrap: wrap;
    max-width: 321px;
    width: fit-content;
`;

export const StyledBlockIcon = styled(BlockIcon)`
    position: absolute;
    right: 0;
`;

type BoxOptionItem = {
    id: string;
    image: string;
    color: string;
    name: string;
};
type BoxOptionType = {
    item: BoxOptionItem;
    onClick: (value: string) => void;
    selectedId: string;
    availableStock: boolean;
};

export const BoxOption = ({ item, onClick, selectedId, availableStock }: BoxOptionType) => (
    <Box
        key={item.name}
        aria-label="Color Option Button"
        onClick={() => onClick(item.id)}
        selected={selectedId === item.id}
        type="button"
    >
        <>
            {!availableStock && <StyledBlockIcon />}
            <Inner key={item.color} color={`#${item.color}`} image={item.image} />
        </>
    </Box>
);
export default Box;
